import { useEffect, useState } from "react";

export default function useCmsContent(loader, initialData = []) {
  const [data, setData] = useState(initialData);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function loadContent() {
      try {
        const nextData = await loader();
        if (isMounted) {
          setData(nextData);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    }

    loadContent();

    return () => {
      isMounted = false;
    };
  }, [loader]);

  return { data, isLoading };
}
